import { render, staticRenderFns } from "./SubjectsReferredDismissedTable.vue?vue&type=template&id=577cacb8&"
import script from "./SubjectsReferredDismissedTable.vue?vue&type=script&lang=js&"
export * from "./SubjectsReferredDismissedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports